
import { mapActions } from 'vuex'
import {
  AisInstantSearch,
  // AisSearchBox,
  // AisHits,
  AisStats,
  AisRefinementList,
  AisClearRefinements,
  // AisToggleRefinement,
  // AisPagination,
  // AisPanel,
  AisMenuSelect,
  AisConfigure,
  AisInfiniteHits,
  AisSortBy
} from 'vue-instantsearch'
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { simple as simpleStateMapping } from 'instantsearch.js/es/lib/stateMappings';
import 'instantsearch.css/themes/satellite-min.css'
import algoliasearch from 'algoliasearch/lite'

// import JobCard from '@/components/Jobs/JobCard.vue'
// import JobSearchInfinite from '@/components/Jobs/JobSearchInfinite.vue'
import jobsData from '@/data/jobs.json'
const algoliaClient = algoliasearch(
  '6CXFQTPZG1',
  'ee00dfb41ca6a3c3ebfb33a6876120b6'
)

// Algolia can't sort randomly, so the main hits request fetches every matching
// job in one go, orders it by a per-visit seed (featured jobs first), and serves pages from that.
// This stops employers who post lots of jobs from dominating the first pages.
// "Newest first" is a virtual index for AisSortBy: it reuses the same fetch, sorted by date.
const NEWEST_INDEX = 'Jobs_newest'
const SHUFFLE_FETCH_LIMIT = 1000 // Algolia's max hitsPerPage / paginationLimitedTo
const SHUFFLE_ATTRIBUTES = ['url', 'title', 'thumbnail', 'type', 'tagline', 'date', 'date_timestamp', 'featured', 'geo_country_long']
const shuffleCache = {}
let shuffleSeed = null

function getShuffleSeed() {
  if (shuffleSeed) {
    return shuffleSeed
  }
  try {
    shuffleSeed = sessionStorage.getItem('jobShuffleSeed')
    if (!shuffleSeed) {
      shuffleSeed = String(Math.random())
      sessionStorage.setItem('jobShuffleSeed', shuffleSeed)
    }
  } catch (e) {
    shuffleSeed = shuffleSeed || String(Math.random())
  }
  return shuffleSeed
}

// FNV-1a, so each job keeps the same relative position as filters change
function hashString(str) {
  let hash = 2166136261
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

function getShuffledResult(indexName, params) {
  const key = indexName + JSON.stringify(params)
  if (!shuffleCache[key]) {
    const seed = getShuffleSeed()
    shuffleCache[key] = algoliaClient.search([{
      indexName,
      params: {
        ...params,
        page: 0,
        hitsPerPage: SHUFFLE_FETCH_LIMIT,
        attributesToRetrieve: SHUFFLE_ATTRIBUTES,
        attributesToHighlight: []
      }
    }]).then(({ results }) => {
      const result = results[0]
      // Featured jobs stay first in both orders
      const items = result.hits.map(hit => ({
        hit,
        featured: hit.featured ? 0 : 1,
        rank: hashString(hit.objectID + seed),
        posted: hit.date_timestamp || Date.parse(hit.date) || 0
      }))
      const random = [...items]
        .sort((a, b) => a.featured - b.featured || a.rank - b.rank)
        .map(item => item.hit)
      const newest = [...items]
        .sort((a, b) => a.featured - b.featured || b.posted - a.posted)
        .map(item => item.hit)
      return { result, random, newest }
    }).catch((error) => {
      delete shuffleCache[key]
      throw error
    })
  }
  return shuffleCache[key]
}

// Point requests for the virtual "newest" index back at the real Jobs index
const toRealIndex = request => (request.indexName === NEWEST_INDEX ? { ...request, indexName: 'Jobs' } : request)

const searchClient = {
  search(requests) {
    // Facet count requests use hitsPerPage: 0 and go straight to Algolia
    const isHitsRequest = request => request.params && request.params.hitsPerPage > 0
    const passThrough = requests.filter(request => !isHitsRequest(request)).map(toRealIndex)
    const passThroughResults = passThrough.length
      ? algoliaClient.search(passThrough).then(({ results }) => results)
      : Promise.resolve([])

    let passThroughIndex = 0
    return Promise.all(requests.map((request) => {
      if (!isHitsRequest(request)) {
        const position = passThroughIndex++
        return passThroughResults.then(results => results[position])
      }
      const { page = 0, hitsPerPage, ...params } = request.params
      return getShuffledResult('Jobs', params).then(({ result, random, newest }) => {
        const hits = request.indexName === NEWEST_INDEX ? newest : random
        return {
          ...result,
          hits: hits.slice(page * hitsPerPage, (page + 1) * hitsPerPage),
          page,
          hitsPerPage,
          nbPages: Math.ceil(hits.length / hitsPerPage)
        }
      })
    })).then(results => ({ results }))
  },
  searchForFacetValues(requests) {
    return algoliaClient.searchForFacetValues(requests.map(toRealIndex))
  }
}
export default {
  components: {
    // JobCard,
    AisInstantSearch,
    AisConfigure,
    // AisSearchBox,
    // AisHits,
    AisClearRefinements,
    // AisToggleRefinement,
    AisStats,
    AisRefinementList,
    // AisPagination,
    //  AisPanel,
    AisMenuSelect,
    AisInfiniteHits,
    AisSortBy
  },
  data() {
    return {
      searchClient,
      routing: {
        router: historyRouter(),
        stateMapping: simpleStateMapping(),
      },
      filters: [],
      sortOptions: [
        { value: 'Jobs', label: 'Shuffled' },
        { value: NEWEST_INDEX, label: 'Newest first' },
      ],
      array: [],
      jobs:[],
      jobTypeEnum: {
        Full_Time:"FULL_TIME",
        Graduate:"OTHER",
        Internship:"INTERN",
        Part_Time:"PART_TIME",
        Summer_Camp:"TEMPORARY",
        Temporary:"TEMPORARY",
        Voluntary:"VOLUNTEER"
      },
      salaryPerEnum: {
        "1": "HOUR",
        "2":"DAY",
        "3":"WEEK",
        "4":"MONTH"
      },
      nbHits: '',
    }
  },
  head() {
      if(this.itemsList.length > 0 && this.itemsList.length === this.jobs.length){
        return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
  computed:{
    itemsList() {
      const jobsSchemaList = []
      this.jobs.forEach((job, index) => {
        this.getLocation(job)
        this.getEducationRequirements(job)
        this.getQualifications(job)
        this.getSalary(job)
        this.getValidThrough(job)
        jobsSchemaList.push(
          {
          "@type":"ListItem",
          "position":index+1,
          "item": {
          "@type":"JobPosting",
          "title":job.title,
          "employmentType": this.jobTypeEnum[job.contract_type.replace(' ', '_')],
          "datePosted": this.$nuxt.$options.filters.convertDateSimple(job.created_at, 'YYYY-MM-DD'), // FORMAT THIS YYYY-MM-DD
          "description": job.description,
          "identifier": {
            "@type": "PropertyValue",
            "name":job.company_name,
            "value": job.job_reference,
          },
          "directApply": false,
          "industry" : "Education",
          "qualifications": job.qualifications,
          "validThrough": job.validThrough,
          "hiringOrganization": {
            "@type" : "Organization",
            "name" : job.company_name,
          },
          "image": job.thumbnail
        }
      })
        // conditionally add to schema here
        if (job.jobLocation === "TELECOMMUTE") {
          jobsSchemaList[index].item.jobLocationType = job.jobLocation
          jobsSchemaList[index].item.applicantLocationRequirements =[{
            "@type": "Country",
            "name": "UK"
          },{
            "@type": "Country",
            "name": "USA"
          }]
        }else {
          jobsSchemaList[index].item.jobLocation = job.jobLocation
        }
        if(job.degree_required === '1') {
          jobsSchemaList[index].item.educationRequirements = {
              "@type": "EducationalOccupationalCredential",
              "credentialCategory": "bachelor degree" }
          }

          jobsSchemaList[index].item.baseSalary = job.baseSalary
      })
      return jobsSchemaList
    },
    structuredData() {
      return {
        "@context":"https://schema.org",
        "@type":"ItemList",
        "itemListElement": this.itemsList
      }
    },
  //   structuredDataBreadcrumbs() {
  //     return {
  //       "@context": "https://schema.org",
  //       "@type":"BreadcrumbList",
  //       "@id":"https://www.tefl.org/tefl-jobs-centre/",
  //       "itemListElement":[{"@type":"ListItem","position":1,"name":"TEFL Jobs Centre","item":"https://www.tefl.org/tefl-jobs-centre/"}]
  //     }
  // }
},
  async mounted() {
    console.log('getting jobs data for schema')
    const jobs = []
   await jobsData.forEach((job) => {
    console.log(job.application_deadline)
    const expiry = job.application_deadline?Math.floor(new Date(job.application_deadline).getTime() / 1000):8640000000000000
    console.log(expiry)
    if (job.status === 'approved' && expiry > Math.floor(new Date().getTime() / 1000)){
      jobs.push(job)
    }
  })
  this.jobs= jobs

  },
  created() {

  },
  methods: {
    ...mapActions({
      updatePaginationLinks: 'jobSearch/updatePaginationLinks'
    }),
    showOnline(items) {
      console.log(items)
      //  items.filter((item) => item.label[0] === 'A');
      return items.filter((item) => item.value === 'Online')
    },
    doOnline(event) {
      console.log(event)
      this.filters = [['location:Online']]
    },
    makeLinkArray(items) { // do a map here instead
      this.array = []
      items.forEach((item) => {
        this.array.push(item.url)
      })
      this.updatePaginationLinks(this.array)
      return items
    },
    transformItems(items, {results}) {
      console.log(results.nbHits)
      this.nbHits = results.nbHits
      return items.map(item => ({
        ...item,
        label: item.label === 'true' ? 'Required' :'Not Required'
      }))
    },
    visibilityChanged(isVisible) {
      if (isVisible && !this.state.isLastPage) {
        this.state.showMore();
      }
    },
    getLocation(job) {
      if(job.location === 'Online') {
        job.jobLocation =  "TELECOMMUTE"
      } else {
        job.jobLocation =  {
          "@type":"Place",
          "address": {
            "@type":"PostalAddress",
            "addressLocality": job.geolocation_city,
            "addressCountry": job.geolocation_country_long
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": job.geolocation_long,
            "longitude": job.geolocation_lat
            }
		}
         }
    },
    getSalary(job) {
      console.log('getting salary for schema')

      if(job.salary) {
        job.baseSalary = {
        "@type":"MonetaryAmount",
        "currency": job.salary_currency,
        "value": {
          "type": "QuantitativeValue",
          "value": job.salary_number,
          "unitText": this.salaryPerEnum[job.salary_per]
            }
          }
        }
    },
    getEducationRequirements(job) {
      console.log('getting education requirements for schema')
      if(job.degree_required === '1') {
          job.educationRequirements = 'Degree required'
        } else {
          job.educationRequirements = 'No degree required'
        }
    },
    getQualifications(job) {
      job.qualifications = job.certificate_hours+' TEFL certificate required'
    },
    getValidThrough(job) {
      console.log('getting valid through date for schema')
      if(job.application_deadline){
          job.validThrough = job.application_deadline
        } else {
          // If no expiry say job expires in a month
          const now = Date.now()
          const month = now + 2629800000
          job.validThrough = this.$nuxt.$options.filters.convertDateSimple(month, 'YYYY-MM-DD')
        }
    }
  },
}
